export default {
    props: {
        messagesPlaceholder: {
            type: String,
            default: undefined,
            kComposite: 'messages.placeholder'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-chat-vue-wrapper/src/KendoChat/Messages.js